import { render, staticRenderFns } from "./DiscoveriesDialog.vue?vue&type=template&id=36df2bcd"
import script from "./DiscoveriesDialog.vue?vue&type=script&lang=js"
export * from "./DiscoveriesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports